module.exports = __webpack_public_path__ + "media/images/svg/list-7ad9ccd7d18b8554f8028dcd9ea583df.svg";